// Implements: F-SHR-013
/**
 * Mockup v3 P8: the "Ver como visitante" overlay for one share target, drawn into `document.body`
 * so no popover, table or scrolling ancestor clips it.
 *
 * The frame reads `GET /mockups/{id}/share-preview` (C6) under the person's session: the very frame
 * a link serves, with no share token, so nothing here asks for a `/share/` address and no visit is
 * ever counted. The callers mount it keyed by the target (checklist 14).
 */

import type { ReactElement } from "react";
import { createPortal } from "react-dom";

import { shareLinkPreviewDocumentPath, sharePreviewDocumentPath } from "../../../shared/ui/frameDocumentPath";
import type { VisitorPreviewTarget } from "../../../types/sharing";
import { VisitorPreview } from "../components/VisitorPreview";

export interface VisitorPreviewContainerProps {
  readonly target: VisitorPreviewTarget;
  readonly onClose: () => void;
}

/** The identity of a target, for the `key` its callers mount the overlay with. */
export function visitorKey(target: VisitorPreviewTarget): string {
  return `${target.mockupId}|${target.artifact}|${target.versionId ?? "current"}|${target.linkId ?? "draft"}`;
}

export function VisitorPreviewContainer({ target, onClose }: VisitorPreviewContainerProps): ReactElement {
  return createPortal(
    <VisitorPreview
      src={
        target.linkId === null
          ? sharePreviewDocumentPath(target.mockupId, target.artifact, target.versionId)
          : shareLinkPreviewDocumentPath(target.mockupId, target.linkId)
      }
      label={target.label}
      onClose={onClose}
    />,
    document.body,
  );
}
